import { Component, OnInit } from '@angular/core';

/**
 * Representa la interfaz de loader
 *
 * @class LoaderComponent
 * @component
 */
@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {
  /**
   * @property {string} caption - Mensaje de carga
   */
  public caption: string;

  /**
   * Crea la interfaz de loader
   * @constructor
   */
  constructor() { }

  ngOnInit() {
  }
}
